import * as React from "react";
import styles from './MissionSection.module.scss';

export default function MissionSection() {
  return (
    <section className={styles.missionSection}>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/f53c3ee72cd77c983cc462f5fe3056cee7dc5f6c4027efa047c0569a8e9ec595?placeholderIfAbsent=true&apiKey=a517fac07ef946f8ab57e1424b0111c7"
        className={styles.backgroundImage}
        alt=""
      />
      <div className={styles.contentWrapper}>
        <h2 className={styles.missionTitle}>Our Mission</h2>
        <p className={styles.missionStatement}>
          We build, invest, collaborate to become the world's largest
          interactive immersive experience.
        </p>
      </div>
    </section>
  );
}